// Extend interfaces for privacy control properties
export interface NavigatorWithPrivacyControls extends Navigator {
  globalPrivacyControl?: boolean
}

/**
 * Check for user privacy control signals.
 *
 * As of v4.7.0, we introduce support for Global Privacy Control (GPC) as our
 * privacy signal standard. We chose GPC over the legacy Do Not Track (DNT)
 * signals because GPC was designed to address DNT's shortcomings and lack of
 * legal enforcement, providing a universal, legally binding mechanism for users
 * to exercise their privacy rights.
 *
 * DNT signals (navigator.doNotTrack, window.doNotTrack, navigator.msDoNotTrack)
 * are deprecated, have poor browser adoption, and are not recommended for use
 * by MDN and modern privacy frameworks.
 *
 * @param navigator - The navigator object to check for privacy controls
 * @returns true if privacy controls indicate user has opted out of tracking
 */
export function checkPrivacyControls(
  navigator: NavigatorWithPrivacyControls,
): boolean {
  // Check for Global Privacy Control (GPC)
  if (navigator.globalPrivacyControl) {
    return true // GPC is active, user opts out of tracking
  }

  return false // No privacy control signals detected
}
